import { ALEX_PROXY_MODE, ALEX_PROXY_MODE_URL_PARAM } from '@shared/environment';

export function turnAlexProxyOn(): void {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(ALEX_PROXY_MODE_URL_PARAM, ALEX_PROXY_MODE.REMOTE);
    window.location.search = searchParams.toString();
}

export function turnAlexProxyOff(): void {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete(ALEX_PROXY_MODE_URL_PARAM);
    window.location.search = searchParams.toString();
}
